// Normal notifications
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const DISMISS_NOTIFICATIONS = 'DISMISS_NOTIFICATIONS';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

// Persistent notifications
export const ADD_PERSISTENT_NOTIFICATION = 'ADD_PERSISTENT_NOTIFICATION';
export const DISMISS_PERSISTENT_NOTIFICATIONS = 'DISMISS_PERSISTENT_NOTIFICATIONS';
export const REMOVE_PERSISTENT_NOTIFICATION_BY_ID = 'REMOVE_PERSISTENT_NOTIFICATION_BY_ID';
